import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionUpdateHandlerService {
  public permissionData: any = null;
  constructor() {}
}
